import PropTypes from "prop-types";
import {
  FilterSectionWrapper,
  FilterSectionHeader,
  AllCheckboxItem,
  CheckboxListItem,
  SearchableFilterContainer,
  FilterListContainer,
  EmptyStateMessage,
} from "./FilterSection";

const FilterSection = ({
  id,
  isOpen,
  onClick,
  title,
  count,
  items,
  checkedItems,
  onToggle,
  onAllToggle,
  onSearch,
  selectAllFlag,
  onUnselect,
  placeholder,
  searchValue,
  helperText,
  onKeyDown,
  isSearchable = false,
  filteredItems = null,
  allItemsChecked,
  someItemsChecked,
  showEmptyState = false,
  isThirdPartyApp = false,
}) => {
  const displayItems = filteredItems || items;
  
  const getItemProps = (item) => {
    if (isThirdPartyApp && id === "channel") {
      return {
        disabled: true,
        onClick: undefined,
        customStyles: {
          cursor: "not-allowed",
          color: "#9e9e9e!important",
        },
      };
    }
    return { onClick: onToggle(item) };
  };

  const renderCheckboxItems = () => (
    <>
      {id !== "channel" && (
        <AllCheckboxItem
          onClick={onAllToggle}
          checked={allItemsChecked}
          indeterminate={someItemsChecked}
        />
      )}
      {displayItems
        .filter((item) => item !== "")
        .map((item) => (
          <CheckboxListItem
            key={item}
            item={item}
            isChecked={checkedItems.includes(item)}
            {...getItemProps(item)}
          />
        ))}
    </>
  );

  return (
    <FilterSectionWrapper id={id}>
      <FilterSectionHeader
        isOpen={isOpen}
        onClick={onClick}
        title={title}
        count={count}
      />
      {showEmptyState && !isSearchable && (
        <FilterListContainer isOpen={isOpen}>
          <EmptyStateMessage message={`No ${title} Available`} />
        </FilterListContainer>
      )}
      {!showEmptyState && (
        <>
          {isSearchable ? (
            <SearchableFilterContainer
              isOpen={isOpen}
              searchPlaceholder={placeholder}
              onSearchChange={onSearch}
              selectAllFlag={selectAllFlag}
              onUnselectClick={onUnselect}
              searchValue={searchValue}
              helperText={helperText}
              onKeyDown={onKeyDown}
            >
              {renderCheckboxItems()}
            </SearchableFilterContainer>
          ) : (
            <FilterListContainer isOpen={isOpen}>
              {renderCheckboxItems()}
            </FilterListContainer>
          )}
        </>
      )}
    </FilterSectionWrapper>
  );
};

FilterSection.propTypes = {
  id: PropTypes.string,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string,
  count: PropTypes.string,
  items: PropTypes.array,
  checkedItems: PropTypes.array,
  onToggle: PropTypes.func,
  onAllToggle: PropTypes.func,
  onSearch: PropTypes.func,
  selectAllFlag: PropTypes.bool,
  onUnselect: PropTypes.func,
  placeholder: PropTypes.string,
  searchValue: PropTypes.string,
  helperText: PropTypes.string,
  onKeyDown: PropTypes.func,
  isSearchable: PropTypes.bool,
  filteredItems: PropTypes.array,
  allItemsChecked: PropTypes.bool,
  someItemsChecked: PropTypes.bool,
  showEmptyState: PropTypes.bool,
  isThirdPartyApp: PropTypes.bool,
};

export const OEMDrawerFilter3rdParty = ({
  categoryObjectList,
  modelObjectList,
  countryObjectList,
  ECUTypesObjectList,
  apiObjectList,
  channelOpen,
  statusOpen,
  categoryOpen,
  modelOpen,
  ecuOpen,
  countryOpen,
  ApiLevelOpen,
  paymentOpen,
  channelListchecked,
  statusListchecked,
  categoryListChecked,
  modelListChecked,
  ecuListchecked,
  countryListchecked,
  apiLevelListchecked,
  paymentListchecked,
  searchApiLevel,
  selectAllCategoryFlag,
  selectAllModelFlag,
  selectAllCountryFlag,
  selectAllECUFlag,
  selectAllApiFlag,
  channelType,
  statusArray,
  paymentArray,
  handleChannelClick,
  handleStatusClick,
  handleCategoryClick,
  handleModelClick,
  handleECUClick,
  handleCountryClick,
  handleApiLevelClick,
  handlePaymentClick,
  handleChannelToggle,
  handleStatusToggle,
  handleCategoryToggle,
  handleModelToggle,
  handleECUToggle,
  handleCountryToggle,
  handleAPILevelToggle,
  handlePaymentToggle,
  handleAllStatusToggle,
  handleAllCategoryToggle,
  handleAllModelToggle,
  handleAllEcuToggle,
  handleAllCountryToggle,
  handleAllApilevelToggle,
  handleAllPaymentToggle,
  handleUnselectCategory,
  handleUnselectModel,
  handleUnselectECU,
  handleUnselectCountry,
  handleUnselectApiLevel,
  handleCategorySearch,
  handleModelSearch,
  handleECUSearch,
  handleCountrySearch,
  handleApiLevelSearch,
  filteredCategory,
  filteredModel,
  filteredECUTypes,
  filteredCountry,
  filteredApiLevel,
  appType,
}) => {
  const filteredChannels = channelType.filter((channel) => {
    if (appType === "3rd Party Apps") {
      return channel === "PROD";
    }
    return true;
  });

  return (
    <div>
      {/* Channel Types */}
      <FilterSection
        id="channel"
        isOpen={channelOpen}
        onClick={handleChannelClick}
        title="Channel Types"
        items={filteredChannels}
        checkedItems={channelListchecked}
        onToggle={handleChannelToggle}
        onAllToggle={undefined}
        allItemsChecked={false}
        someItemsChecked={false}
        isThirdPartyApp={appType === "3rd Party Apps"}
      />

      {/* Status */}
      <FilterSection
        id="status"
        isOpen={statusOpen}
        onClick={handleStatusClick}
        title="Status"
        items={statusArray}
        checkedItems={statusListchecked}
        onToggle={handleStatusToggle}
        onAllToggle={handleAllStatusToggle}
        allItemsChecked={statusListchecked.length === statusArray.length}
        someItemsChecked={
          statusListchecked.length > 0 &&
          statusListchecked.length < statusArray.length
        }
      />

      {/* Categories */}
      <FilterSection
        id="category"
        isOpen={categoryOpen}
        onClick={handleCategoryClick}
        title="Categories"
        count={`${categoryListChecked.length}/${
          Object.keys(categoryObjectList).filter((item) => item !== "").length
        }`}
        items={Object.keys(categoryObjectList)}
        filteredItems={filteredCategory}
        checkedItems={categoryListChecked}
        onToggle={handleCategoryToggle}
        onAllToggle={handleAllCategoryToggle}
        onSearch={handleCategorySearch}
        selectAllFlag={selectAllCategoryFlag}
        onUnselect={handleUnselectCategory}
        placeholder="Search for Category"
        allItemsChecked={
          filteredCategory.length > 0 &&
          filteredCategory.every((item) => categoryListChecked.includes(item))
        }
        someItemsChecked={
          filteredCategory.some((item) =>
            categoryListChecked.includes(item)
          ) &&
          !filteredCategory.every((item) =>
            categoryListChecked.includes(item)
          )
        }
        isSearchable={true}
      />

      {/* Models */}
      <FilterSection
        id="model"
        isOpen={modelOpen}
        onClick={handleModelClick}
        title="Models"
        count={`${modelListChecked.length}/${
          Object.keys(modelObjectList).filter((item) => item !== "").length
        }`}
        items={Object.keys(modelObjectList)}
        filteredItems={filteredModel}
        checkedItems={modelListChecked}
        onToggle={handleModelToggle}
        onAllToggle={handleAllModelToggle}
        onSearch={handleModelSearch}
        selectAllFlag={selectAllModelFlag}
        onUnselect={handleUnselectModel}
        placeholder="Search for Model"
        allItemsChecked={modelListChecked.length === filteredModel.length}
        someItemsChecked={
          modelListChecked.length > 0 &&
          modelListChecked.length < filteredModel.length
        }
        isSearchable={true}
      />

      {/* ECU Type */}
      {(ECUTypesObjectList === undefined ||
        ECUTypesObjectList.length === 0) && (
        <FilterSection
          id="ecu"
          isOpen={ecuOpen}
          onClick={handleECUClick}
          title="ECU Type"
          count={`${ecuListchecked.length}/${ECUTypesObjectList?.length || 0}`}
          items={ECUTypesObjectList || []}
          checkedItems={ecuListchecked}
          onToggle={handleECUToggle}
          onAllToggle={handleAllEcuToggle}
          allItemsChecked={false}
          someItemsChecked={false}
          showEmptyState={true}
          isSearchable={false}
        />
      )}
      {ECUTypesObjectList !== undefined && ECUTypesObjectList.length > 0 && (
        <FilterSection
          id="ecu"
          isOpen={ecuOpen}
          onClick={handleECUClick}
          title="ECU Type"
          count={`${ecuListchecked.length}/${ECUTypesObjectList?.length || 0}`}
          items={ECUTypesObjectList}
          filteredItems={filteredECUTypes}
          checkedItems={ecuListchecked}
          onToggle={handleECUToggle}
          onAllToggle={handleAllEcuToggle}
          onSearch={handleECUSearch}
          selectAllFlag={selectAllECUFlag}
          onUnselect={handleUnselectECU}
          placeholder="Search for ECU Type"
          allItemsChecked={ecuListchecked.length === filteredECUTypes.length}
          someItemsChecked={
            ecuListchecked.length > 0 &&
            ecuListchecked.length < filteredECUTypes.length
          }
          isSearchable={true}
        />
      )}

      {/* Country */}
      <FilterSection
        id="country"
        isOpen={countryOpen}
        onClick={handleCountryClick}
        title="Country"
        count={`${countryListchecked.length}/${countryObjectList.length}`}
        items={countryObjectList}
        filteredItems={filteredCountry}
        checkedItems={countryListchecked}
        onToggle={handleCountryToggle}
        onAllToggle={handleAllCountryToggle}
        onSearch={handleCountrySearch}
        selectAllFlag={selectAllCountryFlag}
        onUnselect={handleUnselectCountry}
        placeholder="Search for Country"
        allItemsChecked={
          filteredCountry.length > 0 &&
          filteredCountry.every((item) => countryListchecked.includes(item))
        }
        someItemsChecked={
          filteredCountry.some((item) =>
            countryListchecked.includes(item)
          ) &&
          !filteredCountry.every((item) =>
            countryListchecked.includes(item)
          )
        }
        isSearchable={true}
      />

      {/* API Level */}
      <FilterSection
        id="apiLevel"
        isOpen={ApiLevelOpen}
        onClick={handleApiLevelClick}
        title="API Level"
        count={`${apiLevelListchecked.length}/${apiObjectList?.length || 0}`}
        items={apiObjectList}
        filteredItems={filteredApiLevel}
        checkedItems={apiLevelListchecked}
        onToggle={handleAPILevelToggle}
        onAllToggle={handleAllApilevelToggle}
        onSearch={handleApiLevelSearch}
        selectAllFlag={selectAllApiFlag}
        onUnselect={handleUnselectApiLevel}
        placeholder="Search for API"
        searchValue={searchApiLevel}
        helperText={
          apiObjectList.length > 0 ? "Greater than or Equal to" : undefined
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
        allItemsChecked={
          filteredApiLevel.length > 0 &&
          filteredApiLevel.every((item) =>
            apiLevelListchecked.includes(item)
          )
        }
        someItemsChecked={
          filteredApiLevel.some((item) =>
            apiLevelListchecked.includes(item)
          ) &&
          !filteredApiLevel.every((item) =>
            apiLevelListchecked.includes(item)
          )
        }
        isSearchable={true}
      />

      {/* Payments */}
      <FilterSection
        id="payment"
        isOpen={paymentOpen}
        onClick={handlePaymentClick}
        title="Payments"
        items={paymentArray}
        checkedItems={paymentListchecked}
        onToggle={handlePaymentToggle}
        onAllToggle={handleAllPaymentToggle}
        allItemsChecked={paymentListchecked.length === paymentArray.length}
        someItemsChecked={
          paymentListchecked.length > 0 &&
          paymentListchecked.length < paymentArray.length
        }
      />
    </div>
  );
};

OEMDrawerFilter3rdParty.propTypes = {
  categoryObjectList: PropTypes.object,
  modelObjectList: PropTypes.object,
  countryObjectList: PropTypes.array,
  ECUTypesObjectList: PropTypes.array,
  apiObjectList: PropTypes.array,
  channelOpen: PropTypes.bool,
  statusOpen: PropTypes.bool,
  categoryOpen: PropTypes.bool,
  modelOpen: PropTypes.bool,
  ecuOpen: PropTypes.bool,
  countryOpen: PropTypes.bool,
  ApiLevelOpen: PropTypes.bool,
  paymentOpen: PropTypes.bool,
  channelListchecked: PropTypes.array,
  statusListchecked: PropTypes.array,
  categoryListChecked: PropTypes.array,
  modelListChecked: PropTypes.array,
  ecuListchecked: PropTypes.array,
  countryListchecked: PropTypes.array,
  apiLevelListchecked: PropTypes.array,
  paymentListchecked: PropTypes.array,
  searchApiLevel: PropTypes.string,
  selectAllCategoryFlag: PropTypes.bool,
  selectAllModelFlag: PropTypes.bool,
  selectAllCountryFlag: PropTypes.bool,
  selectAllECUFlag: PropTypes.bool,
  selectAllApiFlag: PropTypes.bool,
  channelType: PropTypes.array,
  statusArray: PropTypes.array,
  paymentArray: PropTypes.array,
  handleChannelClick: PropTypes.func,
  handleStatusClick: PropTypes.func,
  handleCategoryClick: PropTypes.func,
  handleModelClick: PropTypes.func,
  handleECUClick: PropTypes.func,
  handleCountryClick: PropTypes.func,
  handleApiLevelClick: PropTypes.func,
  handlePaymentClick: PropTypes.func,
  handleChannelToggle: PropTypes.func,
  handleStatusToggle: PropTypes.func,
  handleCategoryToggle: PropTypes.func,
  handleModelToggle: PropTypes.func,
  handleECUToggle: PropTypes.func,
  handleCountryToggle: PropTypes.func,
  handleAPILevelToggle: PropTypes.func,
  handlePaymentToggle: PropTypes.func,
  handleAllStatusToggle: PropTypes.func,
  handleAllCategoryToggle: PropTypes.func,
  handleAllModelToggle: PropTypes.func,
  handleAllEcuToggle: PropTypes.func,
  handleAllCountryToggle: PropTypes.func,
  handleAllApilevelToggle: PropTypes.func,
  handleAllPaymentToggle: PropTypes.func,
  handleUnselectCategory: PropTypes.func,
  handleUnselectModel: PropTypes.func,
  handleUnselectECU: PropTypes.func,
  handleUnselectCountry: PropTypes.func,
  handleUnselectApiLevel: PropTypes.func,
  handleCategorySearch: PropTypes.func,
  handleModelSearch: PropTypes.func,
  handleECUSearch: PropTypes.func,
  handleCountrySearch: PropTypes.func,
  handleApiLevelSearch: PropTypes.func,
  filteredCategory: PropTypes.array,
  filteredModel: PropTypes.array,
  filteredECUTypes: PropTypes.array,
  filteredCountry: PropTypes.array,
  filteredApiLevel: PropTypes.array,
  appType: PropTypes.string,
};
